export const WEBPHONE_DISABLED_PATHS = ["/login", "/recover-password", "/sign-up", "/subscribe", "/subscribe/team", "/legacy-system"]
